<section class="navbar-links d-flex justify-content-center">
  <ul class="d-flex align-items-center parent m-0">

    <li class="text-center">
      <a [routerLink]="['/', lang]" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
        <p>Home</p>
      </a>
    </li>

    <li class="text-center" *ngFor="let item of mainCategoryList; trackBy: trackBySlug">
      <a [routerLink]="['/', lang, 'categories', item.slug]" routerLinkActive="active"
        (click)="navigateToCategory(item)">
        <p>{{ getName(item) }}</p>
      </a>
    </li>
  </ul>
</section>